// src/helpers/parseNumeric.js
// Parsers numéricos robustos para campos financieros.
// Empty/null/undefined → { value: 0, valid: true } (se trata como cero).
// Cualquier texto no parseable o NaN → { valid: false } para que el caller pueda mostrar error.

const stripFormatting = (value) =>
  String(value ?? "")
    .replace(/[\s$,]/g, "")
    .trim();

export function parseMoney(value, { allowNegative = false } = {}) {
  const raw = String(value ?? "");
  const cleaned = stripFormatting(value);
  if (cleaned === "") return { value: 0, valid: true, raw };
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return { value: NaN, valid: false, raw };
  if (!allowNegative && n < 0) return { value: n, valid: false, raw };
  return { value: n, valid: true, raw };
}

export function parseInteger(value, { allowNegative = false, min = null, max = null } = {}) {
  const raw = String(value ?? "");
  const cleaned = stripFormatting(value);
  if (cleaned === "") return { value: 0, valid: true, raw };
  const n = Number(cleaned);
  if (!Number.isFinite(n) || !Number.isInteger(n)) return { value: NaN, valid: false, raw };
  if (!allowNegative && n < 0) return { value: n, valid: false, raw };
  if (min !== null && n < min) return { value: n, valid: false, raw };
  if (max !== null && n > max) return { value: n, valid: false, raw };
  return { value: n, valid: true, raw };
}
